// extracted by mini-css-extract-plugin
export default {"content":"SocietyGallery_content__jTYol","realContent":"SocietyGallery_realContent__wKH8C"};